import { Component, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'
import HighFilter from '@/components/highFilter/index.vue'
import { queryTeacherAdminTADetail, editTADetail, editTACourse, editTASuggest, editTAOther, editTAStatus, queryTACourseList } from '@/api'
@Component({ name: 'TeamList', components: { HighFilter } })
export default class TeamList extends Vue {
  private editVisible: any = false
  private showPersonal: any = true
  private showInformation: any = true
  private showEvaluate: any = true
  private quitVisible: any = false
  private fileList: any = []
  private taOptions: any = [
    { value: 1, label: '是' },
    { value: 0, label: '否' }
  ] // 是否培训

  private responsibilityOptions: any = [] // 责任心能力
  private majorOptions: any = [] // 专业能力
  private EnglishOptions: any = [] // 英语能力
  private workStatusList: any = [{ val: 1, name: '在职' }, { val: 2, name: '离职' }]

  private projectPersonal: any = {
    id: "'",
    index: '',
    school: '',
    realName: '',
    gender: '', // 性别
    nation: '', // 民族
    phone: '',
    email: '',
    level: '', // 年级（第几届）
    major: '', // 上学时专业
    canTeachProfessional: '', // 可带专业
    houseHoldRegister: '' // 户口属性
  } // 基本信息

  private projectEvaluate: any = {
    isSuggestContinue: '', // -1.无；0，否；1，是
    suggestNoContinueCause: '' // 不建议续用原因
  } // 评价信息

  private projectCarid: any = {
    idCard: '', // 证件号码
    idCardType: '', // 证件号码类型
    bankCardId: '', // 银行卡号
    bankAddress: '', // 开户行及支行 地址
    payeeName: '' // 收款人姓名
  } // 身份证信息

  private projectCaridCopy: any = { }

  private tableData2: any = []

  private genderList: any = [{ val: 1, name: '男' }, { val: 2, name: '女' }]
  private pageType: any = null
  private currentPage: any = 1
  private filterResult: any = null
  private totalPage: any = 1
  private filterData: any = null
  created () {
    this.pageType = this.$route.query.type
    this.initData()
    this.initPagequeryTACourse()
  }

  private async initData () {
    const result: any = await queryTeacherAdminTADetail({ id: this.$route.query.id })
    this.projectPersonal = result.common
    this.projectEvaluate = result.suggest
    this.projectCarid = result.other
    this.projectCaridCopy = JSON.parse(JSON.stringify(this.projectCarid))
  }

  private async initPagequeryTACourse () {
    const param: any = { page: this.currentPage, limit: 20, id: this.$route.query.id }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result1: any = await queryTACourseList(param)
    this.totalPage = result1.allPage
    this.currentPage = result1.currentPage
    this.tableData2 = result1.courseList
    this.filterData = result1.search
  }

  private rowClicked () {
    this.showInformation = true
  }

  private async savePersonal () {
    this.projectPersonal.id = this.$route.query.id
    const { error }: any = await editTADetail(this.projectPersonal)
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
    }
  }

  private async saveInformation () {
    const { error }: any = await editTACourse({ courseList: this.tableData2 })
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      // this.showInformation = false
      this.initPagequeryTACourse()
    }
  }

  private async saveEvaluate () {
    this.projectEvaluate.id = this.$route.query.id
    const { error }: any = await editTASuggest(this.projectEvaluate)
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
    }
  }

  private async saveCarid () {
    this.projectCaridCopy.id = this.$route.query.id
    const { error }: any = await editTAOther(this.projectCaridCopy)
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      this.editVisible = false
      this.initData()
    }
  }

  private async editStatus () {
    const { error }: any = await editTAStatus({ id: this.$route.query.id, status: 2 })
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      this.quitVisible = false
      this.$router.go(-1)
      TagsViewModule.delView(this.$route)
    }
  }
}
